import { render, staticRenderFns } from "./Usda.vue?vue&type=template&id=6a1920b0&scoped=true&lang=html&"
import script from "./Usda.vue?vue&type=script&lang=js&"
export * from "./Usda.vue?vue&type=script&lang=js&"
import style0 from "./Usda.vue?vue&type=style&index=0&id=6a1920b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1920b0",
  null
  
)

export default component.exports